
// FIXME [FW-137] Converting backflipp urls from http to https should not be
//                done on the client, there should be no assumption that the
//                resource or url works over https.
export function https(href: string) {
	if (!href) {
		return null;
	}
	const a = document.createElement("a");
	a.href = href;
	a.protocol = "https";
	return a.href;
}
